module.exports = __webpack_public_path__ + "img/width-wide.5a500ac.jpg";